import BaseApi from '@/api/Base/BaseApi'
import { CommonListPayload } from '@/api/DatasetNode/types'
import {
  CreateModelVersionPayload,
  ModelVersionListPayload,
  ModelVersionListResponse,
  ModelVersionMetaResponse,
  ModelVersionResponse,
  PasteModelVersionPayload,
  UpdateModelVersionPayload,
  ExternalModelListForSemiAutoLabelingResponse,
  GetRetrainModelVersionListPayload
} from '@/api/ModelVersion/types'
import { ProjectNodeType } from '@/api/Project/types'

const ROOT = '/model-version'

const defaultPaginationOptions = {
  itemsPerPage: 15,
  page: 0,
}

export default class ModelVersionApi extends BaseApi {
  createModelVersion(payload: CreateModelVersionPayload) {
    const { modelNodeId, name } = payload
    return this.agent.post<ModelVersionResponse>(`${ROOT}/${modelNodeId}`, { name })
  }

  deleteModelVersion(modelVersionId: string) {
    return this.agent.delete(`${ROOT}/${modelVersionId}`)
  }

  getModelVersionDetail(modelVersionId: string) {
    return this.agent.get<ModelVersionResponse>(`${ROOT}/${modelVersionId}`)
  }

  updateModelVersion(payload: UpdateModelVersionPayload) {
    const { modelVersionId, name } = payload
    return this.agent.put<ModelVersionResponse>(`${ROOT}/${modelVersionId}`, { name })
  }

  pasteModelVersion(payload: PasteModelVersionPayload) {
    const { modelVersionId, position } = payload
    return this.agent.post<ModelVersionResponse>(`${ROOT}/${modelVersionId}/paste`, position)
  }

  getModelVersionList(projectId: string, options?: ModelVersionListPayload) {
    const { itemsPerPage, page, category } = { ...defaultPaginationOptions, ...options }

    return this.agent.get<ModelVersionListResponse>(`${ROOT}/${projectId}/list`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        ...(category && { category }),
      },
    })
  }

  getRetrainModelVersionList(projectId: string, options: GetRetrainModelVersionListPayload) {
    const { itemsPerPage, page, nodeType, nodeId } = options ?? defaultPaginationOptions

    return this.agent.get<ModelVersionListResponse>(`${ROOT}/${projectId}/retrain-list`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        nodeType,
        nodeId,
      },
    })
  }

  getSemiAutoLabelingModelVersionList(modelVersionId: string, options?: CommonListPayload) {
    const { itemsPerPage, page } = options ?? defaultPaginationOptions

    return this.agent.get<ModelVersionListResponse>(`${ROOT}/${modelVersionId}/semi-auto-list`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        model_size: 'LARGE',
      },
    })
  }

  getModelVersionMeta(modelNodeId: string) {
    return this.agent.get<ModelVersionMetaResponse>(`${ROOT}/${modelNodeId}/version-meta`)
  }

  getExternalModelListForSemiAutoLabeling(modelVersionId: string, options?: CommonListPayload) {
    const { itemsPerPage, page } = options ?? defaultPaginationOptions

    return this.agent.get<ExternalModelListForSemiAutoLabelingResponse>(`${ROOT}/${modelVersionId}/external-models`, {
      params: {
        page,
        num_per_page: itemsPerPage,
      },
    })
  }
}
